var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bad.length)?_c('div',{staticClass:"bad"},[_c('h3',[_vm._v("Плохо")]),_vm._l((_vm.bad),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(item))])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }